/*
 * Created on Tue Jul 09 2019
 *
 * Copyright (c) 2019 Laboratori Guglielmo Marconi
 */
import { NgModule }                         from '@angular/core';
import { Routes, RouterModule }             from '@angular/router';
//GENERICS
import { PageNotFoundComponent }            from './pages/page-not-found/page-not-found.component';
import { PermissionDeniedComponent }        from './pages/permission-denied/permission-denied.component';
import { LoginComponent }                   from './login/login.component';
import { DashboardComponent }               from './pages/dashboard/dashboard.component';
import { ErrorSettingsComponent }           from './pages/error-settings/error-settings.component';
import { TestPageComponent }                from './pages/testing_page/test-page.component';
import { RefereeComponent }                 from './layout/referee.component';
import { AdminDashboardComponent }          from './pages/admin/admin-dashboard.component';

import { AuditManagerComponent }            from './pages/audit/audit-manager.component';
import { UserManagerComponent }             from './pages/users/user-manager.component';
import { UserCreateEditComponent }          from './pages/users/user-create-edit.component';
import { IconsComponent }                   from './pages/icons/icons.component';
import { NewLoginComponent }                from './login/new-login.component';

//-------------- ZimbraInstance -----------------
import { ZimbraInstanceManagerComponent }        from './pages/zimbrainstance/zimbrainstance-manager.component';
import { ZimbraInstanceCreateEditComponent }     from './pages/zimbrainstance/zimbrainstance-create-edit.component';

import { ForceLogoutComponent }           from './pages/forcelogout/forcelogout.component';


const routes: Routes = [
  
  { path : 'login'                          , component : LoginComponent            },
  { path : 'adminlogin'                     , component : NewLoginComponent         },
  { path: ''                                , component : RefereeComponent          },
  { path : 'test'                           , component : TestPageComponent         },
  { path : 'forcelogout'                    , component : ForceLogoutComponent      },
  { path : 'icons'                          , component : IconsComponent            },
  { path: 'dashboard'                       ,  data: { breadcrumb: { label : 'Home' ,  info: { icon: 'home' } }  } ,
    children:
      [
        {
          path: '', component: DashboardComponent, pathMatch: 'full'
        },           
        {
          path: 'admin', data: { breadcrumb: { label : 'admin.settings' ,  info: { icon: 'settings' } }  },
          children:
            [
              {
                path: '', component: AdminDashboardComponent, pathMatch: 'full'
              },
              {
                path: 'zimbrainstance', data: { breadcrumb: { label : 'zimbrainstance.manage' ,  info: { icon: 'account_box' } } },
                children:
                  [
                    { path: ''            , component: ZimbraInstanceManagerComponent     , pathMatch : 'full' },
                    { path: 'create'      , component: ZimbraInstanceCreateEditComponent  , data      : { breadcrumb: { label : 'zimbrainstance.manage' , info : {  icon: 'add_circle' } } }, children: [] },
                    { path: 'create/:id'  , component: ZimbraInstanceCreateEditComponent  , data      : { breadcrumb: { label : 'zimbrainstance.manage' , info : { icon: 'create' } } }, children: [] },
                  ]
              },
              {
                path: 'audit', data: { breadcrumb: { label : 'audit.change_log' ,  info: { icon: 'assignment' } }  },
                children:
                  [
                    { path: '', component: AuditManagerComponent, pathMatch: 'full' }
                  ]
              },
              {
                path: 'users', data: { breadcrumb: { label : 'admin.users' ,  info: { icon: 'account_box' } } },
                children:
                  [
                    { path: ''            , component: UserManagerComponent     , pathMatch : 'full' },
                    { path: 'create'      , component: UserCreateEditComponent  , data      : { breadcrumb: { label : 'users.manage' , info : {  icon: 'add_circle' } } }, children: [] },
                    { path: 'create/:id'  , component: UserCreateEditComponent  , data      : { breadcrumb: { label : 'users.manage' , info : { icon: 'create' } } }, children: [] },
                  ]
              }
            ]
        }
      ]
  },


  
  //pathmatch full is required to allow Angular to use activate routing with different query params.
  //withtout that parameter, for angular: path?query=ciao and path?query=addio will be the same and no router will be launch

  { path: '404'                             , component : PageNotFoundComponent     },
  { path: '403'                             , component : PermissionDeniedComponent },
  { path: 'serror'                          , component : ErrorSettingsComponent    },
  { path: 'serror/:errorcode'               , component : ErrorSettingsComponent    },

  { path: '**'                              , redirectTo : '404'} 
  
];

@NgModule({
  
  imports: [RouterModule.forRoot(routes , { enableTracing: false, onSameUrlNavigation: 'reload'  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

